import { Dropdown, DropdownProps, type MenuProps } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { IconSize, IconType, IconWrap } from '../../..';
import { theme } from '../../theme/semanticTokens';
import { Button, type ButtonProps } from '../Button';

type NonEmptyArray<T> = [T, ...T[]];

export interface ButtonDropdownProps {
  items: NonEmptyArray<NonNullable<MenuProps['items']>[number]>;
  customTrigger?: React.ReactNode;
  buttonText?: string;
  placement?:
    | 'bottom'
    | 'bottomLeft'
    | 'bottomRight'
    | 'top'
    | 'topLeft'
    | 'topRight';
  disabled?: boolean;
  className?: string;
  size?: ButtonProps['size'];
  variant?: ButtonProps['variant'];
  trigger?: DropdownProps['trigger'];
}

const StyledDropdown = styled(Dropdown)`
  .ant-dropdown-menu {
    .ant-dropdown-menu-item:hover {
      background-color: ${theme.dime.colors.surface.primaryHover};
    }
  }
`;

export const ButtonDropdown: React.FC<ButtonDropdownProps> = ({
  items,
  customTrigger,
  size = 'large',
  buttonText = 'Select',
  placement = 'bottomRight',
  disabled = false,
  className,
  variant = 'secondary',
  trigger = ['hover']
}) => {
  const expandIconNode = (
    <IconWrap
      type={IconType.ChevronRight}
      size={IconSize.Small}
      style={{
        color: theme.dime.colors.icon.primary
      }}
    />
  );

  return (
    <>
      <style>
        {`
          .dime-button-dropdown-menu .ant-dropdown-menu-submenu-title .ant-dropdown-menu-title-content { margin-right: ${theme.dime.spacing.m}; }
        `}
      </style>
      <StyledDropdown
        menu={{
          items,
          expandIcon: expandIconNode,
          rootClassName: 'dime-button-dropdown-menu'
        }}
        placement={placement}
        disabled={disabled}
        className={className}
        trigger={trigger}
      >
        {customTrigger || (
          <Button
            size={size}
            variant={variant}
            disabled={disabled}
            iconRight={IconType.ChevronDown}
          >
            {buttonText}
          </Button>
        )}
      </StyledDropdown>
    </>
  );
};
